import { FlatterFilesResponse } from './fitting-product.model';

export interface FittingQueryParams {
  pipeSizeId?: number;
  classId?: number;
  designCodeId?: number;
  designFactorId?: number;
  branchSizeId?: number;
  flangeTypeId?: number;
  maxDesignPressure?: number;
  designPressureUnit?: number;
  minDesignTemp?: number;
  maxDesignTemp?: number;
  maxCeId?: number;
  limit125?: number;
  fittingTypeId?: number;
  hemisphereId?: number;
  designTempMin?: number;
  designTempMax?: number;
  designTempUnit?: string;
  isDirty: boolean;
  isBuyAmerica?: number;
}

export function fittingQueryParamsFactory(obj: Partial<FittingQueryParams>): FittingQueryParams {
  return {
    pipeSizeId: obj.pipeSizeId || -1,
    classId: obj.classId || 1,
    designCodeId: obj.designCodeId || -1,
    designFactorId: obj.designFactorId || -1,
    branchSizeId: obj.branchSizeId || -1,
    flangeTypeId: obj.flangeTypeId || -1,
    maxDesignPressure: obj.maxDesignPressure,
    designPressureUnit: obj.designPressureUnit || 1,
    minDesignTemp: obj.minDesignTemp || -1,
    maxDesignTemp: obj.maxDesignTemp || -1,
    maxCeId: obj.maxCeId || -1,
    limit125: obj.limit125 || -1,
    fittingTypeId: obj.fittingTypeId || -1,
    hemisphereId: obj.hemisphereId || -1,
    designTempMin: obj.designTempMin,
    designTempMax: obj.designTempMax,
    designTempUnit: obj.designTempUnit || 'F',
    isDirty: obj.isDirty || false,
    isBuyAmerica: obj.isBuyAmerica || -1
  }
}


// Generated by https://quicktype.io

export interface FittingDetail {
  pipeSize?: string;
  class?: string;
  branchSize?: string;
  flangeType?: string;
  maxCe?: number;
  id?: number;
  partNumber: string;
  productName: string;
  description?: string;
  pipeSizeId?: number;
  classId?: number;
  designFactorId?: number;
  branchSizeId?: number;
  flangeTypeId?: number;
  maxDesignPressure?: number;
  minDesignTemp?: number;
  maxDesignTemp?: number;
  maxCeid?: number;
  limit125?: boolean;
  notes?: string;
  drawing?: any;
  restricted?: number;
  restrictedNotice?: string;
  inactiveDate?: string;
  createdDate?: string;
  createdBy?: string;
  updatedDate?: string;
  updatedBy?: string;
  fittingTypeId?: string;
  hemisphereId?: string;
  fittingTypeText?: string;
  hemisphereText?: string;
  designCodes?: string;
  designFactor?: string;
  maxDesignPressureInBar?: number;
  image?: string | null;
  surge?: number;
  leadTime?: number;
  isBuyAmerica?: boolean;

  designPressures: DesignPressure[];
  associatedProducts: AssociatedProduct[];
  replacedParts: string[];
}

export function fittingDetailFactory(obj: Partial<FittingDetail>): FittingDetail {
  return {
    pipeSize: obj.pipeSize,
    class: obj.class,
    branchSize: obj.branchSize,
    flangeType: obj.flangeType,
    maxCe: obj.maxCe,
    id: obj.id,
    partNumber: obj.partNumber || '',
    productName: obj.productName || '',
    description: obj.description,
    pipeSizeId: obj.pipeSizeId,
    classId: obj.classId,
    designFactorId: obj.designFactorId,
    branchSizeId: obj.branchSizeId,
    flangeTypeId: obj.flangeTypeId,
    maxDesignPressure: obj.maxDesignPressure,
    minDesignTemp: obj.minDesignTemp,
    maxDesignTemp: obj.maxDesignTemp,
    maxCeid: obj.maxCeid,
    limit125: obj.limit125,
    notes: obj.notes,
    drawing: obj.drawing,
    restricted: obj.restricted,
    restrictedNotice: obj.restrictedNotice,
    inactiveDate: obj.inactiveDate,
    createdDate: obj.createdDate,
    createdBy: obj.createdBy,
    updatedDate: obj.updatedDate,
    updatedBy: obj.updatedBy,
    fittingTypeId: obj.fittingTypeId,
    hemisphereId: obj.hemisphereId,
    fittingTypeText: obj.fittingTypeText,
    hemisphereText: obj.hemisphereText,
    designCodes: obj.designCodes,
    designFactor: obj.designFactor,
    maxDesignPressureInBar: obj.maxDesignPressureInBar,
    surge: obj.surge,
    leadTime: obj.leadTime,
    designPressures: obj.designPressures || [],
    associatedProducts: obj.associatedProducts || [],
    replacedParts: obj.replacedParts || [],
  }
}

export interface AssociatedProduct {
  id: number;
  productName: string;
  partNumber: string;
  hasDrawing: boolean;

  configurations: ProductConfiguration[]
  additionalDrawings: { [key: string]: FlatterFilesResponse }
}

export interface DesignPressure {
  createdBy: string
  createdDate: string
  designFactor: number
  designFactorId: number
  id: number
  inbar: number
  maxDesignPressure: number
  updatedBy: string
  updatedDate: string
}


// Generated by https://quicktype.io

export interface AvailableConfiguration {
  suffix: string;
  description: string;
  commercialDescription: string;
  axDescription: string;

  productConfigurations: ProductConfiguration[];
  availableConfigurationFilters: AvailableConfigurationFilter[];
}

export interface AvailableConfigurationFilter {
  id: number,
  suffix: string,
  name: string,
  value: string | number | boolean,
  dataType: string
}

interface BaseEntity {
  createdDate?: string;
  updatedDate?: string;
  createdBy?: string;
  updatedBy?: string;
}

export interface ProductConfiguration extends BaseEntity {
  id?: number;
  productNumber?: string;
  productLine?: string;
  suffix?: string;
  isActive?: boolean;
  availableConfiguration?: AvailableConfiguration;
  commercialDescription?: string;

  surge?: number;
  leadTime?: number;
}

export function productConfigurationFactory(obj: Partial<ProductConfiguration>): ProductConfiguration {
  return {
    id: obj.id,
    productNumber: obj.productNumber,
    productLine: obj.productLine,
    suffix: obj.suffix,
    isActive: obj.isActive,
    availableConfiguration: obj.availableConfiguration,
    commercialDescription: obj.commercialDescription,
    updatedBy: obj.updatedBy,
    updatedDate: obj.updatedDate,
    createdBy: obj.createdBy,
    createdDate: obj.createdDate,
    surge: obj.surge,
    leadTime: obj.leadTime
  }
}

// Generated by https://quicktype.io

export interface Inventtxt {
  dataareaid: string;
  itemid: string;
  inventdimid: string;
  languageid: string;
  txt: string;
  recversion: number;
  recid: number;
  modifieddatetime: string;
  modifiedby: string;
  createddatetime: string;
  createdby: string;
  actionDate: string;
}



export interface ConfigurationFilter {
  // magInspection?: boolean;
  magInspection?: boolean;
  buyAmerica?: boolean;
  liftingLugs?: boolean;
  specialInspection?: boolean;
  tappedBlind?: string;
  oring?: string;
  bevel?: string;
}

export function configurationFilterFactory(obj: Partial<ConfigurationFilter>) {
  return {
    // magInspection: obj.magInspection,
    magInspection: obj.magInspection || false,
    buyAmerica: obj.buyAmerica || false,
    liftingLugs: obj.liftingLugs || false,
    tappedBlind: obj.tappedBlind,
    oring: obj.oring,
    bevel: obj.bevel,
  }
}

